@if (isVisible()) {
<div class="app-download-banner">
  <div class="app-download-banner__header">
    <p class="app-download-banner__text">{{ 'APP_DOWNLOAD_BANNER_TEXT' | localization }}</p>
    <button
      type="button"
      class="app-download-banner__close"
      [attr.aria-label]="'BUTTON_CLOSE' | localization"
      (click)="dismiss()"
    >
      <nz-icon nzType="close" nzTheme="outline"></nz-icon>
    </button>
  </div>
  <div class="app-download-banner__stores">
    @for (store of stores; track store.url) {
    <a
      class="app-download-banner__store"
      [href]="store.url"
      target="_blank"
      rel="noopener noreferrer"
      [attr.aria-label]="store.title"
    >
      <img [src]="store.image" [alt]="store.title" width="155" height="45" />
    </a>
    }
  </div>
</div>
}
